import { Reducer } from 'redux';
import {
    OnboardingState,
    OnboardingActionTypes,
    LoadOnboardingSuccessAction,
    SaveOnboardingStartAction,
    OpenVideoOverlayAction,
    OnboardingLoadingState,
} from './types';

const defaultState: OnboardingState = {
    isSaving: false,
    isSaved: false,
    loaded: OnboardingLoadingState.Default,
    isAlreadySaved: false,
    openVideo: null,
};

const saveOnboardingStart = (state: OnboardingState, action: SaveOnboardingStartAction): OnboardingState => ({
    ...state,
    isSaving: true,
    isSaved: false,
    savedData: { ...state.savedData, ...action.payload },
});

const saveOnboardingSuccess = (state: OnboardingState): OnboardingState => ({
    ...state,
    isSaving: false,
    isSaved: true,
    isAlreadySaved: true,
});

const saveOnboardingError = (state: OnboardingState): OnboardingState => ({
    ...state,
    isSaving: false,
    isSaved: false,
});

const loadOnboardingStart = (state: OnboardingState): OnboardingState => ({
    ...state,
    loaded: OnboardingLoadingState.Loading,
});

const loadOnboardingSuccess = (state: OnboardingState, action: LoadOnboardingSuccessAction): OnboardingState => {
    try {
        return {
            ...state,
            loaded: OnboardingLoadingState.Loaded,
            data: action.payload,
            savedData: JSON.parse(action.payload.OnboardingStatusData),
            isAlreadySaved: !!action.payload.OnboardingStatusData,
        };
    } catch {
        return {
            ...state,
            loaded: OnboardingLoadingState.Loaded,
            data: action.payload,
            savedData: null,
            isAlreadySaved: false,
        };
    }
};

const loadOnboardingError = (state: OnboardingState): OnboardingState => ({
    ...state,
    loaded: OnboardingLoadingState.Error,
});

const openVideoOverlay = (state: OnboardingState, action: OpenVideoOverlayAction): OnboardingState => ({
    ...state,
    openVideo: action.payload.videoId,
});

const closeVideoOverlay = (state: OnboardingState): OnboardingState => ({
    ...state,
    openVideo: null,
});

const finishOnboarding = (state: OnboardingState): OnboardingState => ({
    ...state,
    isFinished: true,
});

const reducer: Reducer<OnboardingState> = (state: OnboardingState = defaultState, action): OnboardingState => {
    switch (action.type) {
        case OnboardingActionTypes.SAVE_ONBOARDING_START:
            return saveOnboardingStart(state, action as SaveOnboardingStartAction);
        case OnboardingActionTypes.SAVE_ONBOARDING_SUCCESS:
            return saveOnboardingSuccess(state);
        case OnboardingActionTypes.SAVE_ONBOARDING_ERROR:
            return saveOnboardingError(state);
        case OnboardingActionTypes.LOAD_ONBOARDING_START:
            return loadOnboardingStart(state);
        case OnboardingActionTypes.LOAD_ONBOARDING_SUCCESS:
            return loadOnboardingSuccess(state, action as LoadOnboardingSuccessAction);
        case OnboardingActionTypes.LOAD_ONBOARDING_ERROR:
            return loadOnboardingError(state);
        case OnboardingActionTypes.OPEN_VIDEO_OVERLAY:
            return openVideoOverlay(state, action as OpenVideoOverlayAction);
        case OnboardingActionTypes.CLOSE_VIDEO_OVERLAY:
            return closeVideoOverlay(state);
        case OnboardingActionTypes.FINISH_ONBOARDING:
            return finishOnboarding(state);
        default:
            return state;
    }
};

export { reducer as onboarding };

export default reducer;
